/* istanbul ignore file */
import React from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import AuthContext from './AuthContext';
import UserWrapper from '../user/UserWrapper';

/*
    Auth Process:
        1. attempt to access site with no CAS cookie/session variable and no code in URL
        2. redirected to login page
        3. login page redirects back with code in URL
        4. code extracted from URL and used to call CAS API to get CAS token
        5. store token in cookie and session and proceed to site
 */

export function AuthWrapper() {
    let cas = getExistingToken();

    if (window.location.href.match(/\/#orders\//)) {
        authenticateCpos(window.location.href.match(/([^/]+$)/)[0]);
    } else if (!cas || cas === 'null') {
        const code = window.location.href.match(/(?:^|[&?])code=([^&]*)/);
        if (code && code.length === 2) {
            getAccessToken(code);
        } else {
            getCode();
        }
    }

    return cas && cas !== 'null' ? (
        <AuthContext.Provider value={'Bearer ' + cas}>
            <UserWrapper />
        </AuthContext.Provider>
    ) : (
        <div>Logging In...</div>
    );
}

function getExistingToken() {
    let cas = sessionStorage.getItem('accessToken');
    if (!cas || cas === 'null') {
        cas = Cookies.get('CASTGC');
    }
    if (cas && cas !== 'null') {
        sessionStorage.setItem('accessToken', cas);
        Cookies.set('CASTGC', cas, { domain: 'costcutter.com', path: '/' });
    }
    return cas;
}

function getCode() {
    // TODO: Replace client ID
    window.location.href =
        window.CONFIG['ws.cas.oauth.authorize'] +
        '?client_id=' +
        window.CONFIG['activoc-react-web.cas.clientid'] +
        '&redirect_uri=' +
        encodeURIComponent(window.location.href);
}

function getAccessToken(code) {
    const hrefExcludingCode = window.location.href.replace(/[&?]code=([^&]*&?)/g, '');

    const data =
        'redirect_uri=' +
        encodeURIComponent(hrefExcludingCode) +
        '&' +
        'code=' +
        encodeURIComponent(code[1]) +
        '&' +
        'client_id=' +
        window.CONFIG['activoc-react-web.cas.clientid'];

    axios
        .post(window.CONFIG['ws.cas.oauth.accessToken'], data, {
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            }
        })
        .then(authSuccess)
        .catch(authFailure);
}

function authenticateCpos(key) {
    axios
        .get(window.CONFIG['ws.cas-token-repository-api.entry'].replace('{accessKey}', key))
        .then(authSuccessCpos)
        .catch(() => {
            Cookies.remove('CASTGC', { domain: 'costcutter.com', path: '/' });
            sessionStorage.removeItem('accessToken');
            let redirect = '?service=' + encodeURIComponent(window.location.origin);
            window.location.href = window.CONFIG['ws.cas.logout'] + redirect;
        });
}

function authSuccess(result) {
    const tokens = result.data.match(/access_token=(.+)&expires/);
    if (tokens && tokens.length === 2) {
        sessionStorage.setItem('accessToken', tokens[1]);
        Cookies.set('CASTGC', tokens[1], { domain: 'costcutter.com', path: '/' });
        window.location.href = window.location.href.replace(/[&?]code=([^&]*&?)/g, '');
    }
}

function authFailure(result) {
    alert('Authorization error: ' + result);
}

function authSuccessCpos(result) {
    const tokens = result.data.tokenValue.match(/access_token=(.+)&expires/);
    if (tokens && tokens.length === 2) {
        sessionStorage.setItem('accessToken', tokens[1]);
        Cookies.set('CASTGC', tokens[1], { domain: 'costcutter.com', path: '/' });
    }
    // Pre-submit & Navigate to order
    const orderId = window.location.href.match(/\/#orders\/([0-9]*)\/.*/)[1];
    axios
        .post(
            window.CONFIG['ws.activoc-web-order-api.orders.submit.nomerge'].replace('{id}', orderId),
            {},
            {
                headers: {
                    Authorization: tokens[1],
                    'Content-Type': 'application/json'
                }
            }
        )
        .then(() => {
            window.location.href = window.location.href.replace(
                /\/#orders\/([0-9]*)\/.*/,
                '/order/' + orderId
            );
        });
}
